const formatUrlSearchParameters = (parameters: any): URLSearchParams => {
  const record: Record<string, string> = {};

  for (const [key, value] of Object.entries(parameters)) {
    if (value) {
      record[key] = String(value);
    }
  }

  return new URLSearchParams(record);
};

export default formatUrlSearchParameters;
